import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Programs } from "./pages/Programs";
import { Grants } from "./pages/Grants";
import { PressRelease } from "./pages/PressRelease";
import { Newsroom } from "./pages/Newsroom";
import { PCAPartnership } from "./pages/PCAPartnership";
import { FallGrantees } from "./pages/FallGrantees";
import { OutOfBounds } from "./pages/OutOfBounds";
import { GetInvolved } from "./pages/GetInvolved";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/grants" element={<Grants />} />
            <Route path="/grants/press-release" element={<PressRelease />} />
            <Route path="/newsroom" element={<Newsroom />} />
            <Route path="/newsroom/press-release" element={<PressRelease />} />
            <Route path="/newsroom/pca-partnership" element={<PCAPartnership />} />
            <Route path="/newsroom/fall-grantees-2026" element={<FallGrantees />} />
            <Route path="/newsroom/out-of-bounds" element={<OutOfBounds />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
